export default "__VITE_ASSET__B2IH3bZE__"